<template>
  <div>
    <DeviceList :isInApp="true"></DeviceList>
  </div>
</template>

<script>
import { baseMixin } from '@/libs/app-mixin'
import DeviceList from '@/components/blocks/DeviceList'

export default {
  name: 'inAppDevices',
  mixins: [baseMixin],
  components: {
    DeviceList
  },
  data () {
    return {}
  },
  methods: {},
  created () {
    this.now = Date.parse(new Date()) / 1000
    this.$parent.isLoadUser = false
    this.$parent.showHeader = false
    this.$parent.showFooter = false
    this.$parent.showSkeleton = false
    document.title = 'Zerofast'
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/inApp/Devices.vue